/**
 * Generated by orval v8.19.0 🍺
 * Do not edit manually.
 * Dyna ERP API
 * OpenAPI spec version: 1.0.0
 */

export type BatchResponseEntryKind = typeof BatchResponseEntryKind[keyof typeof BatchResponseEntryKind];


export const BatchResponseEntryKind = {
  reimbursement: 'reimbursement',
  advance_payout: 'advance_payout',
  advance_verified: 'advance_verified',
  combined: 'combined',
  advance_unproven: 'advance_unproven',
} as const;
